module.exports = __webpack_public_path__ + "static/img/jrhy.19396805.png";